import { Skeleton, SkeletonItem, makeStyles, tokens } from '@fluentui/react-components';

type TableSkeletonProps = {
  rows: number;
  columns: number;
  /**
   * Accessible label announced by the `role="status"` region. Defaults to a
   * generic "Loading..." — pass a content-specific label (e.g. "Loading
   * connections...") so screen readers describe what is loading.
   */
  label?: string;
};

const useStyles = makeStyles({
  table: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
    padding: tokens.spacingVerticalM,
  },
  row: {
    display: 'flex',
    gap: tokens.spacingHorizontalM,
    alignItems: 'center',
  },
  cell: {
    flex: 1,
  },
});

export const TableSkeleton = ({ rows, columns, label = 'Loading...' }: TableSkeletonProps) => {
  const styles = useStyles();

  return (
    <div role="status" aria-label={label}>
      <Skeleton>
        <div className={styles.table}>
          {Array.from({ length: rows }).map((_, rowIdx) => (
            <div key={rowIdx} className={styles.row}>
              {Array.from({ length: columns }).map((_, colIdx) => (
                <SkeletonItem key={colIdx} size={16} className={styles.cell} />
              ))}
            </div>
          ))}
        </div>
      </Skeleton>
    </div>
  );
};
